import React from "react";
import { Box, Typography } from "@mui/material";
import PlayIcon from "../../ui/PlayIcon";
import ShoppingBagIcon from "../../ui/Bag";

const getThumbnail = (asset, mobileView = false) => {
    if (asset.asset.type !== "photo") {
        if (!mobileView && asset.asset && Object.keys(asset.asset.thumbnails).length > 0) {
            const thmbls = Object.keys(asset.asset.thumbnails);
            return asset.asset.thumbnails[thmbls[thmbls.length - 1]];
        } else {
            return asset.asset.thumbnailUrl;
        }
    }

    if (!mobileView) {
        return asset.asset.sources[1].url;
    } else {
        return asset.asset.sources[asset.asset.sources.length - 1].url;
    }
};

const CarouselItem = ({ asset, onClickItem, index }) => {
    const products = asset?.products?.length || 0;
    const thumbnail = getThumbnail(asset);
    const isVideo = asset.entityType === 1;
    const onClickLocal = () => {
        onClickItem({ item: asset, index: index });
    };

    return (
        <Box position={"relative"}>
            <Box
                onClick={onClickLocal}
                sx={{
                    paddingTop: `100%`,
                    position: "relative",
                    backgroundImage: `url(${thumbnail})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    cursor: "pointer",
                }}
            >
                {isVideo && (
                    <Box
                        position="absolute"
                        sx={{ transform: "translate(-50%, -50%)", top: "50%", left: "50%" }}
                    >
                        <PlayIcon sx={{ width: "48px", height: "48px" }} />
                    </Box>
                )}
                <Box
                    position="absolute"
                    backgroundColor="#ab0000"
                    borderRadius="2px"
                    sx={{
                        left: (theme) => theme.spacing(2),
                        bottom: (theme) => theme.spacing(1),
                    }}
                >
                    <Box
                        px={1}
                        py={"4px"}
                        color="#fff"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Box>
                            <ShoppingBagIcon size={"10px"} />
                        </Box>
                        <Box display="flex" ml={"5px"}>
                            <Typography
                                color={"#ffffff"}
                                sx={{ lineHeight: "16px", fontSize: "12px", marginBottom: "-2px" }}
                                component={"span"}
                            >
                                {products}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

CarouselItem.defaultProps = {
    enableStorefront: false,
};

export default CarouselItem;
